import { api, getAuthHeader } from './help';

export const getBuilding = async (payload) => {
  const response = await api.post('/property/properties', payload, getAuthHeader());
  return response.data;
};

export const getApp = async (payload) => {
  const response = await api.post('/property/application', payload, getAuthHeader());
  return response.data;
};

export const getClaim = async (payload) => {
  const response = await api.post('/property/claim', payload, getAuthHeader());
  return response.data;
};

export const getPolicy = async (data) => {
  const response = await api.post('/property/policy', data, getAuthHeader());
  return response.data;
};

export const cancelPolicies = async (data) => {
  const response = await api.post('/property/cancel-policy', data, getAuthHeader());
  return response.data;
};

export const getBuildingDelegation = async (data) => {
  const response = await api.get('/property/delegation?id=' + data, getAuthHeader());
  return response.data;
};

export const getBuildingInvoice = async (payload) => {
  const buildingId = typeof payload === 'object' && payload !== null ? payload.buildingId : payload;
  const landlordId =
    typeof payload === 'object' && payload !== null ? payload.landlordId : undefined;
  const params = landlordId ? { landlordId } : { id: buildingId };
  const response = await api.get('/property/invoice', {
    ...getAuthHeader(),
    params,
  });
  return response.data;
};

export const getPolicyCancelLogs = async (payload) => {
  const response = await api.post('/property/cancel-logs', payload, getAuthHeader());
  return response.data;
};

export const getPolicyByRiderId = async (riderId) => {
  const response = await api.get('/property/policy/' + riderId, getAuthHeader());
  return response.data;
};

export const getPolicyDetail = async (policyId) => {
  const response = await api.get('/property/policy/detail/' + policyId, getAuthHeader());
  return response.data;
};

export const getApplicationDetail = async (applicationId) => {
  const response = await api.get('/property/application/detail/' + applicationId, getAuthHeader());
  return response.data;
};

export const getClaimDetail = async (claimId) => {
  const response = await api.get('/property/claim/detail/' + claimId, getAuthHeader());
  return response.data;
};

export const getBuildingDetail = async (buildingId) => {
  const response = await api.get('/property/properties/detail/' + buildingId, getAuthHeader());
  return response.data;
};
